import { createElement } from "react";
import binary from "./binary";
import curry from "./curry";

// Component c => c -> Object -> Component
const render = curry(binary(createElement));

export default render;
